import { BASE_URL } from "./constants";

export const COMMUNITY_MEMBERS_API = `${BASE_URL}/api/v2/communities/members`;
export const COMMUNITY_SEARCH_API = `${BASE_URL}/api/v2/communities/search`;
export const COMMUNITY_JOIN_API = `${BASE_URL}/api/v2/communities/join`;
export const FEED_API = `${BASE_URL}/api/v2/communities/posts/feed`;
export const POSTS_API = `${BASE_URL}/api/v2/communities/posts`;
export const PRODUCTV2_API = `${BASE_URL}/api/products/v2`;

export const COMMUNITY_REQUESTS_API = `${BASE_URL}/api/v2/communities/requests`;
export const COMMUNITY_INVITES_API = `${BASE_URL}/api/v2/communities/invites`;

export const COMMUNITY_SETTINGS_API = `${BASE_URL}/api/v2/communities/settings`;
export const MODERATOR_COMMUNITIES_API = `${BASE_URL}/api/v2/communities/moderators`;
export const COMMUNITIES_API = `${BASE_URL}/api/v2/communities`;

export const EVENTS_API = `${BASE_URL}/api/events`;

export const CREATE_PAYMENT_CHECKOUT_SESSION_API = `${BASE_URL}/api/v2/payments/checkout`;
